import { render, staticRenderFns } from "./TraxSettingBackgroundPreview.vue?vue&type=template&id=635802e3"
import script from "./TraxSettingBackgroundPreview.vue?vue&type=script&lang=js"
export * from "./TraxSettingBackgroundPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports